import { Card } from 'react-bootstrap';
import { IJobStats, JobShiftsQuickFilters } from '@th-types/jobs.type';
import { ActivityDetail } from '@th-types/daily-activity.type';
import IJobDetail, {
  JobAssignment,
  ShiftPosition,
} from '@th-types/job.detail.type';
import JobShiftsTableItemMobile from './JobShiftsTableItemMobile';
import JobShiftsHeaderMobile from './JobShiftsHeaderMobile';

import '../style.scss';

interface Props {
  job: IJobDetail;
  jobStats?: IJobStats;
  activities: ActivityDetail[];
  selectedFilter?: JobShiftsQuickFilters;
  completeOnboardingAction: (
    jobAssignment: JobAssignment,
    complete: boolean
  ) => void;
  handleMissingHourNoticed: (shiftPositionId: number) => void;
  handleMissingActivityNoticed: (shiftPositionId: number) => void;
  handleConfirmMarkPaid: (activityDetail: ActivityDetail) => void;
  handleOpenEditShiftModal: (shiftPosition: ShiftPosition) => void;
}

export default function JobShiftsCardMobile({
  job,
  jobStats,
  activities,
  selectedFilter,
  handleConfirmMarkPaid,
  handleOpenEditShiftModal,
  completeOnboardingAction,
  handleMissingHourNoticed,
  handleMissingActivityNoticed,
}: Props) {
  if (!jobStats) {
    return null;
  }

  return (
    <Card className="my-2 mx-3 px-2 job-shifts-card">
      <JobShiftsHeaderMobile job={job} jobStats={jobStats} />
      <JobShiftsTableItemMobile
        key={`${job.id}${activities.map((item) => item.shiftPosition.id).join('-')}`}
        activities={activities}
        job={job}
        handleConfirmMarkPaid={handleConfirmMarkPaid}
        selectedFilter={selectedFilter}
        handleOpenEditShiftModal={handleOpenEditShiftModal}
        completeOnboardingAction={completeOnboardingAction}
        handleMissingHourNoticed={handleMissingHourNoticed}
        handleMissingActivityNoticed={handleMissingActivityNoticed}
      />
    </Card>
  );
}
